import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";

export default function useTopGainers(enabled) {
  const [gainers, setGainers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [scrapeDate, setScrapeDate] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${BASE_URL}/daily-top-gainers?limit=120`);
      setGainers(res.data?.gainers || []);
      setScrapeDate(res.data?.scrape_date || null);
    } catch (e) {
      console.error(e);
      setError("Couldn't load top gainers. Please retry.");
    }
    setLoading(false);
  }, []);

  const refresh = useCallback(async () => {
    setRefreshing(true);
    setError(null);
    try {
      await axios.post(`${BASE_URL}/refresh-top-gainers?limit=120`);
      await load();
    } catch (e) {
      console.error(e);
      setError("Refresh failed. Please try again.");
    }
    setRefreshing(false);
  }, [load]);

  useEffect(() => {
    if (enabled && gainers.length === 0) load();
  }, [enabled, gainers.length, load]);

  return { gainers, loading, error, refresh, refreshing, scrapeDate };
}
